/**
 * مهرِ «این بسته از کدام برنچ منتشر شده».
 *
 * ═══ چرا این فایل هست ═══
 *
 * چند سشن هم‌زمان روی برنچ‌های WHOSUP-… کار می‌کنند و هرکدام که شیپ کند،
 * `dev` و کانالِ OTA همان می‌شوند. از روی صفحه هیچ راهی نبود بفهمی الان
 * کدامشان را داری می‌بینی — این مهر همان جواب است: کنارِ نسخه در ستینگِ
 * اپ و پایینِ پروفایلِ وب می‌نشیند.
 *
 * ═══ چرا یک فایلِ سورس، نه متغیرِ محیطی ═══
 *
 * مسیرِ `eas update --environment` متغیرها را از سرورِ EAS می‌گیرد و
 * `.env` محلی را نادیده می‌گیرد — همان تله‌ای که یک شب کلیدهای Supabase
 * را از باندل انداخت. سرورِ EAS هم از برنچِ گیتِ این ماشین خبر ندارد.
 * فایلِ سورس از هر دو مسیرِ بسته‌بندی (Metro و Vite) بی‌هیچ شرطی رد می‌شود.
 *
 * ═══ چه کسی می‌نویسدش ═══
 *
 * فقط `scripts/publish-update.mjs`، درست پیش از ساختنِ باندل، از روی
 * برنچِ فعلیِ گیت. عمداً در working tree می‌ماند تا کامیتِ «رکوردِ انتشار»
 * آن را به `dev` ببرد — بیلدِ وبِ Cloudflare از همان کامیت ساخته می‌شود و
 * بدونِ این، وب مهرِ کهنه را نشان می‌داد.
 *
 * مقدارِ پیش‌فرضِ خالی یعنی «از مسیرِ publish رد نشده» — مثلِ اجرای محلیِ
 * توسعه. رابط در این حالت چیزی اضافه نشان نمی‌دهد.
 */
export const PUBLISHED_BRANCH = 'main';
/** کامیتِ کوتاهِ کدی که منتشر شد — انتشارِ دوباره‌ی همان تیکت را از قبلی جدا می‌کند. */
export const PUBLISHED_COMMIT = '9a3774e';
/** «WHOSUP-309 · a1b2c3d» — همان که صفحه‌ی QA پیش از هر سناریوی دورِ تیکت می‌خواهد (مایگریشن 0173). */
export const BUILD_STAMP = [PUBLISHED_BRANCH, PUBLISHED_COMMIT].filter(Boolean).join(' · ');
